module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eLcvE"))).then(() => parcelRequire('1iHdE'));